import IconEnum from "../../../../enums/icon.enum";
import SizeEnum from "../../../../enums/size.enum";
import Indicator from "../../../indicator/indicator";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import IPaginationProps from "./pagination.props";

const Pagination = (props: IPaginationProps) => {
  const { active, count, takeSegmentsState, isMasteryCheck, goToSegmentCallback, previewMode } = props;
  const pageSize = 5;
  const currentPage = active || 1;
  const pageCount = count || pageSize;
  const pages = [];
  const [visiblePages, setVisiblePages] = useState({
    startPage: currentPage,
    endPage: pageCount,
    showPrevious: false,
    showNext: false,
    showPages: false
  });

  const handleNavButtonClick = (num: number) =>
    setVisiblePages((prevState) => ({
      startPage: prevState.startPage + num * pageSize,
      endPage: prevState.endPage + num * pageSize,
      showPrevious: prevState.startPage + num * pageSize > 1,
      showNext: pageCount > prevState.endPage + num * pageSize,
      showPages: count > 0 && active > 0
    }));

  const handlePageButtonClick = (segmentId: string, disabled: boolean) => {
    if (previewMode || !disabled) {
      goToSegmentCallback(segmentId);
    }
  };

  const navButton = (previous: boolean) => (
    <Indicator
      size={SizeEnum.LARGE}
      icon={previous ? IconEnum.CHEVRON_LEFT : IconEnum.CHEVRON_RIGHT}
      callback={() => handleNavButtonClick(previous ? -1 : 1)}
    />
  );

  for (let pageNo = visiblePages.startPage; pageNo <= visiblePages.endPage && pageNo <= pageCount; pageNo += 1) {
    const inProgessPage = takeSegmentsState.inProgressSegmentIndex + 1;
    const upcomingPage = pageNo > inProgessPage;
    const disabled = isMasteryCheck || (pageNo === currentPage && inProgessPage === pageNo) || upcomingPage;
    let className = "completed-item";
    if (pageNo === currentPage) className = "active-item";
    else if (upcomingPage) className = "inactive-item";

    pages.push(
      <Button
        key={pageNo}
        aria-label={pageNo.toString()}
        disabled={previewMode ? !previewMode : disabled}
        className={`page-item ${className}`}
        onClick={() => handlePageButtonClick(takeSegmentsState.segmentIds[pageNo - 1], disabled)}
      >
        {pageNo}
      </Button>
    );
  }

  useEffect(() => {
    const pagePos = (Math.ceil(currentPage / pageSize) - 1) * pageSize;
    const startPage = pagePos + 1;
    const endPage = pagePos + pageSize;
    setVisiblePages({
      startPage,
      endPage,
      showPrevious: startPage > pageSize,
      showNext: pageCount > endPage,
      showPages: count > 0 && active > 0
    });
  }, [currentPage, pageCount, active]);

  return (
    <div
      className={`pagination flex-row align-items-center pagination-animation ${
        visiblePages.showPages ? "active" : ""
      }`}
      data-no-translate={true}
    >
      {visiblePages.showPrevious && navButton(true)}
      {visiblePages.showPages && pages}
      {visiblePages.showNext && navButton(false)}
    </div>
  );
};

export default Pagination;
